import { render } from "./table.mobile.vue?vue&type=template&id=77e9b15d&ts=true"
import script from "./table.mobile.vue?vue&type=script&scoped=true&lang=ts"
export * from "./table.mobile.vue?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__